import type { SocialLoginType } from '@/types/socialLogin'

export type AuthActionType = 'login' | 'register'

export type AuthStep = 'login-menu' | 'sign-up' | 'login' | 'forgot-password' | 'reset-password'
export interface PendingThirdPartyAuth {
  /**
   * Token for third-party authentication.
   * - For Google: stores the id_token (JWT) from GIS SDK
   * - For Facebook: stores the access_token from OAuth redirect
   * - For Apple: stores the id_token from Apple Sign In
   */
  accessToken: string
  type: SocialLoginType
  authorizationCode?: string
  name?: string
  redirectUrl?: string
  fallbackUrl?: string
}

export const isAuthStep = (step: string): step is AuthStep => {
  return ['login-menu', 'sign-up', 'login', 'forgot-password', 'reset-password'].includes(step)
}
